import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { DocumentAIService } from './services/documentAI.service';
import { DomSanitizer } from '@angular/platform-browser';

@Directive({
  selector: '[appLazyImage]'
})
export class LazyImageDirective implements OnInit {
  @Input('appLazyImage') imageUrl!: string; // Get image URL as input
  private loader: HTMLElement;
  private loaderContainer: HTMLElement;
  constructor(private el: ElementRef, private renderer: Renderer2,
     private sanitizer: DomSanitizer,
     public service: DocumentAIService) {
      this.loader = this.renderer.createElement('div');

      this.loaderContainer = this.renderer.createElement('div')

      this.renderer.setStyle(this.loaderContainer, 'width', '100%');
      this.renderer.setStyle(this.loaderContainer, 'height', '125px');
      
      this.renderer.setStyle(this.loader, 'position', 'absolute');
      this.renderer.setStyle(this.loader, 'top', '30%');
      this.renderer.setStyle(this.loader, 'left', '40%');
      this.renderer.setStyle(this.loader, 'transform', 'translate(-50%, -50%)');
      this.renderer.setStyle(this.loader, 'width', '30px');
      this.renderer.setStyle(this.loader, 'height', '30px');
      this.renderer.setStyle(this.loader, 'border', '3px solid #f3f3f3');
      this.renderer.setStyle(this.loader, 'borderTop', '3px solid #3498db');
      this.renderer.setStyle(this.loader, 'borderRadius', '50%');
      this.renderer.setStyle(this.loader, 'animation', 'spin 1s linear infinite');
     }

  ngOnInit() {

    if (this.imageUrl) {

      const parent = this.el.nativeElement.parentNode;
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
      this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
  
      // Show loader before image loads
      this.renderer.appendChild(this.loaderContainer, this.loader);
      this.renderer.appendChild(parent, this.loaderContainer);
  

      this.service.getSorterPageImage(this.imageUrl).subscribe((blobUrl:any) => {
        
        let objectURL = 'data:image/png;base64,' + blobUrl.result
        const imagesafeUrl = this.sanitizer.bypassSecurityTrustUrl(objectURL) as any;
          // Preload image before setting src
          const img = new Image();
          img.src = objectURL;
  
          img.onload = () => {
            this.renderer.setStyle(this.el.nativeElement, 'display', 'block'); // Show the image
            this.renderer.setAttribute(this.el.nativeElement, 'src', imagesafeUrl.changingThisBreaksApplicationSecurity);
            this.renderer.removeChild(parent, this.loaderContainer); // Remove loader on success
          };

      });
    }
  }
}
